import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class TabsComponent extends Component {
    static selector () {
        return '.tabs'
    }

    constructor (opts) {
        super(opts)

        this.listen()
        this.render()
        this.onLoad()
    }

    listen () {
        this.getTabs()
            .forEach(tab => {
                tab.addEventListener('click',
                    this.onTabClick.bind(this))

                tab.addEventListener('keydown',
                    this.onTabKeydown.bind(this))
            })

        this.on('resize',
            this.onResize.bind(this))

        this.on('resize:debounced',
            this.onResizeDebounced.bind(this))
    }

    onLoad () {
        if (!this.props.qsParam)
            return

        const qsVal = (window.location.search || '')
            .replace(/^\?/, '')
            .split('&')
            .map(str => str.split('='))
            .filter(arr => arr.length === 2)
            .map(arr => arr[0] === this.props.qsParam
                ? arr[1]
                : null)
            .filter(str => str)[0]

        if (!qsVal)
            return

        const selectedTab = this.getTabSelected()
                && this.getTabSelected()
                    .getAttribute('data-qs-value') === qsVal
            ? this.getTabSelected()
            : this.getTabs()
                .filter(el => el.getAttribute('data-qs-value') === qsVal)[0]

        if (!selectedTab)
            return

        if (selectedTab !== this.getTabSelected())
            selectedTab.click()

        const top = this.el.getBoundingClientRect().top
            + (RootComponent.Scroller.state.get('scrollY') || 0)
            - 50

        Promise
            .resolve(this.getBrowser('name') === 'ios'
                ? window.scrollTo(0, top)
                : RootComponent.Scroller.scrollTo({ y: top }))
            .then(() => {
                selectedTab.style.outline = 'none'
                selectedTab.focus()

                setTimeout(() => {
                    selectedTab.classList.remove('focus-visible')
                    selectedTab.style.outline = ''
                }, 1)

                if (!('history' in window))
                    return

                window.history
                    .replaceState(null, null, window.location.href
                        .replace(new RegExp(`&*${this.props.qsParam}=${
                            qsVal}`), '')
                        .replace(/\?$/, ''))
            })
    }

    onTabClick (e) {
        if (e.target.getAttribute('aria-selected') === 'true')
            return

        this.getTabSelected()
            .setAttribute('aria-selected', false)

        e.target
            .setAttribute('aria-selected', true)

        this.render()
    }

    onTabKeydown (e) {
        const key = (e.key || e.keyIdentifier || '')

        const isArrowLeft = key.match(/arrowleft/i)
        const isArrowRight = key.match(/arrowright/i)
        const isHome = key.match(/home/i)
        const isEnd = key.match(/end/i)

        if (!isArrowLeft
                && !isArrowRight
                && !isHome
                && !isEnd)
            return

        e.preventDefault()
        e.stopPropagation()

        if ((isHome && !e.target.previousElementSibling)
                || (isEnd && !e.target.nextElementSibling))
            return

        let selectedTab

        const tabs = this.getTabs()

        if (isHome || isEnd)
            selectedTab = tabs[isHome ? 0 : tabs.length - 1]

        if (isArrowLeft)
            selectedTab = e.target.previousElementSibling
                || tabs[tabs.length - 1]

        if (isArrowRight)
            selectedTab = e.target.nextElementSibling
                || tabs[0]

        if (!selectedTab)
            return

        selectedTab.click()
        selectedTab.focus()
    }

    onResize () {
        const tabpanelsContainer = this.getTabpanelsContainer()

        if (tabpanelsContainer.style.minHeight)
            tabpanelsContainer.style.minHeight = ''
    }

    onResizeDebounced () {
        const tabpanelsContainer = this.getTabpanelsContainer()

        tabpanelsContainer.style.minHeight
            = `${tabpanelsContainer.clientHeight}px`
    }

    getTabSelected () {
        return this.el.querySelector('[role=tab][aria-selected=true]')
    }

    getTabs () {
        return Array.from(this.el.querySelectorAll('[role=tab]'))
    }

    getTabpanels () {
        return Array.from(this.el.querySelectorAll('[role=tabpanel]'))
    }

    getTabpanelsContainer () {
        return this.el.querySelector('.tabs-panels')
    }

    getTabpanelFromTab (tab) {
        return tab
                && tab.getAttribute('aria-controls')
            ? this.el.querySelector(`#${
                tab.getAttribute('aria-controls')}`)
            : null
    }

    render () {
        const tabpanelsContainer = this.getTabpanelsContainer()

        tabpanelsContainer.style.minHeight
            = `${tabpanelsContainer.clientHeight}px`

        const selectedTab = this.getTabSelected()
            || this.getTabs()[0]

        const selectedTabpanel = selectedTab
            ? this.getTabpanelFromTab(selectedTab)
            : null

        if (!selectedTab || !selectedTabpanel)
            return

        const isChange = selectedTab.getAttribute('aria-selected') !== 'true'
            || !selectedTabpanel.classList.contains('selected')

        if (!isChange)
            return

        this.getTabs()
            .filter(tab => (tab !== selectedTab
                    && (tab.getAttribute('aria-selected')
                            !== 'false'
                        || tab.tabindex !== -1))
                || (tab === selectedTab
                    && (selectedTab.getAttribute('aria-selected')
                            !== 'true'
                        || selectedTab.tabindex !== 0)))
            .forEach(tab => {
                tab.setAttribute('aria-selected', tab === selectedTab)

                tab.setAttribute('tabindex', tab === selectedTab
                    ? 0
                    : -1)
            })

        const tabpanelsContainerStyle = window
            .getComputedStyle(tabpanelsContainer)

        this.getTabpanels()
            .filter(tabpanel => tabpanel.classList.contains('selected')
                && tabpanel !== selectedTabpanel)
            .forEach(tabpanel => tabpanel.classList.remove('selected'))

        const minHeight = `${selectedTabpanel.clientHeight
            + (parseInt(tabpanelsContainerStyle.paddingTop) || 0)
            + (parseInt(tabpanelsContainerStyle.paddingBottom) || 0)}px`

        selectedTabpanel.style.overflow = 'visible'
        selectedTabpanel.style.height = '0'

        tabpanelsContainer.style.minHeight = minHeight

        selectedTabpanel.classList.add('selected')

        setTimeout(() => {
            selectedTabpanel.style.overflow = ''
            selectedTabpanel.style.height = ''
        }, (parseFloat(tabpanelsContainerStyle.transition
            .replace(/^.*min-height\s([\d|.]+).+$/, '$1')) || 0)
                * 1000)
    }
}
